/*
 * Splectrum Picks — site-wide "picks in the cart" counter (loaded with defer
 * from layout/theme.liquid, after Craft's constants.js / pubsub.js).
 *
 * One rule, one number, every surface:
 *   - product page "Buy 5, get 1 free" callout   [data-pack-callout] > [data-pack-meter]
 *     (also inside quick-add popups, which clone the product page's section HTML)
 *   - cart drawer / cart page nudge               [data-pack-nudge] > [data-pack-meter]
 *   - Build-your-six bar                          <build-your-six> > [data-pack-meter]
 *     (assets/build-your-six.js listens for the `splectrum:pack-count` event
 *     for its own text + state class)
 *
 * Counting rule (mirror of snippets/splectrum-pick-count.liquid — change both):
 *   product_type equals config.pick_type (case-insensitive) · not a gift card ·
 *   when config.count_gauge_only, the line's options_with_values contain an
 *   option named like config.gauge_option. /cart.js carries no collections, so
 *   the Liquid "in the picks collection" fallback has no live equivalent.
 *
 * Flow: on load, on Craft's PUB_SUB_EVENTS.cartUpdate, on pageshow and on
 * visibilitychange we fetch /cart.js (or use the full cart Craft already has
 * from /cart/change.js) and re-paint every meter. A debounced MutationObserver
 * hydrates meters injected later (quick-add modal content, re-rendered drawer
 * sections) straight from the last known count — no extra request. When an
 * injected meter carries a fresher Liquid-rendered count (the drawer that
 * Shopify just re-rendered after an add), that count is adopted everywhere at
 * once and a confirming fetch follows.
 *
 * Config: <script type="application/json" id="splectrum-pack-config"> emitted
 * once by layout/theme.liquid from Theme settings → Splectrum picks.
 */
(function () {
  if (window.SplectrumPack) return;

  var cfg = {};
  try {
    var cfgEl = document.getElementById('splectrum-pack-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || '{}') : {};
  } catch (e) {
    cfg = {};
  }

  var packSize = parseInt(cfg.pack_size, 10) || 5;
  var freeCount = parseInt(cfg.free_count, 10) || 1;
  var total = packSize + freeCount;
  var pickType = String(cfg.pick_type || 'Picks').toLowerCase().trim();
  var gaugeOption = String(cfg.gauge_option || 'Gauge').toLowerCase().trim();
  var gaugeOnly = cfg.count_gauge_only !== false; // Liquid default is true
  var repeats = !!cfg.repeats;
  var cartUrl = (cfg.cart_url || '/cart') + '.js';
  var nudgeTexts = cfg.nudge || {};
  var nth = cfg.nth || ordinal(total);

  var STATES = ['progress', 'ready', 'unlocked'];
  var SURFACES = '[data-pack-callout],[data-pack-nudge],[data-pack-meter]';

  function ordinal(n) {
    var mod100 = n % 100;
    var mod10 = n % 10;
    var suffix = 'th';
    if (mod100 < 11 || mod100 > 13) {
      if (mod10 === 1) suffix = 'st';
      else if (mod10 === 2) suffix = 'nd';
      else if (mod10 === 3) suffix = 'rd';
    }
    return n + suffix;
  }

  /* ---- the rule ---------------------------------------------------- */
  function isCart(obj) {
    return !!obj && Array.isArray(obj.items) && typeof obj.item_count === 'number';
  }

  function countCart(cart) {
    if (!isCart(cart)) return null;
    var optionsExposed = cart.items.some(function (i) {
      return Array.isArray(i.options_with_values);
    });
    return cart.items.reduce(function (sum, item) {
      if (item.gift_card) return sum;
      var type = String(item.product_type || '').toLowerCase().trim();
      if (type !== pickType) return sum;
      if (gaugeOnly && optionsExposed) {
        var opts = item.options_with_values || [];
        var hasGauge = opts.some(function (o) {
          return String((o && o.name) || '').toLowerCase().trim() === gaugeOption;
        });
        if (!hasGauge) return sum;
      }
      return sum + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  /* ---- state derivation (mirror of the nudge Liquid) ----------------- */
  function describe(count) {
    count = Math.max(0, parseInt(count, 10) || 0);
    var freeTotal = 0;
    var progress = count;
    if (repeats) {
      freeTotal = Math.floor(count / total);
      progress = count % total;
    }
    var state = 'progress';
    if (repeats && freeTotal > 0) state = 'unlocked';
    else if (count >= total) state = 'unlocked';
    else if (count >= packSize) state = 'ready';

    var remaining = Math.max(packSize - progress, 0);
    var filled = progress;
    if (state === 'unlocked' && !repeats) filled = total;

    return {
      count: count,
      state: state,
      remaining: remaining,
      filled: filled,
      progress: progress,
      freeTotal: freeTotal,
      packSize: packSize,
      freeCount: freeCount,
      total: total,
      nth: nth,
      repeats: repeats,
    };
  }

  function fill(text, d) {
    return String(text == null ? '' : text)
      .replace(/\[count\]/g, d.remaining)
      .replace(/\[pack_size\]/g, d.packSize)
      .replace(/\[free_count\]/g, d.freeCount)
      .replace(/\[total\]/g, d.total)
      .replace(/\[nth\]/g, d.nth)
      .replace(/\[free_total\]/g, d.freeTotal);
  }

  function setState(el, prefix, state) {
    STATES.forEach(function (s) {
      el.classList.remove(prefix + '--' + s);
    });
    el.classList.add(prefix + '--' + state);
  }

  /* ---- painters ------------------------------------------------------ */
  function paintMeter(meter, d) {
    meter.setAttribute('data-pick-count', d.count);
    var dots = meter.querySelectorAll('[data-pack-dot]');
    for (var i = 0; i < dots.length; i++) {
      var on = i < d.filled;
      var was = dots[i].classList.contains('is-filled');
      dots[i].classList.toggle('is-filled', on);
      dots[i].classList.toggle('is-new', on && !was);
    }
    var free = meter.querySelector('[data-pack-free]');
    if (free) {
      free.classList.toggle('is-ready', d.state === 'ready');
      free.classList.toggle('is-filled', d.state === 'unlocked');
    }
  }

  function paintCallout(root, d) {
    root.setAttribute('data-pick-count', d.count);
    setState(root, 'splectrum-pack-callout', d.state);
    var heading = root.querySelector('[data-pack-heading]');
    if (heading) {
      var copy = heading.getAttribute('data-heading-progress') || '';
      if (d.state === 'ready' && heading.getAttribute('data-heading-ready')) {
        copy = heading.getAttribute('data-heading-ready');
      } else if (d.state === 'unlocked' && heading.getAttribute('data-heading-unlocked')) {
        copy = heading.getAttribute('data-heading-unlocked');
      }
      if (copy && heading.textContent !== copy) heading.textContent = copy;
    }
    var sr = root.querySelector('[data-pack-sr]');
    if (sr) {
      var tpl = sr.getAttribute('data-pack-sr') || '[count] of [pack_size] picks in your cart';
      sr.textContent = tpl.replace('[count]', Math.min(d.count, d.packSize)).replace('[pack_size]', d.packSize);
    }
  }

  function paintNudge(root, d) {
    root.setAttribute('data-pick-count', d.count);
    setState(root, 'splectrum-pack-nudge', d.state);
    var textEl = root.querySelector('[data-pack-nudge-text]');
    var key;
    if (d.state === 'unlocked') key = repeats ? 'unlocked_repeat' : 'unlocked';
    else if (d.state === 'ready') key = 'ready';
    else key = d.remaining === 1 ? 'progress_one' : 'progress_other';
    var text = nudgeTexts[key];
    if (textEl && typeof text === 'string') textEl.textContent = fill(text, d);
    var link = root.querySelector('[data-pack-nudge-link]');
    if (link) link.hidden = d.state === 'unlocked';
    // Liquid only renders the nudge once a pick is in the cart; mirror that.
    root.hidden = d.count === 0 || (typeof text === 'string' && text.trim() === '');
  }

  function paintAll(scope, d) {
    scope = scope || document;
    var nodes = [];
    if (scope !== document && scope.matches && scope.matches(SURFACES)) nodes.push(scope);
    var found = scope.querySelectorAll(SURFACES);
    for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-pack-meter')) paintMeter(el, d);
      if (el.hasAttribute('data-pack-callout')) paintCallout(el, d);
      if (el.hasAttribute('data-pack-nudge')) paintNudge(el, d);
    });
  }

  /* ---- store + fetch -------------------------------------------------- */
  var api = {
    config: {
      packSize: packSize,
      freeCount: freeCount,
      total: total,
      pickType: pickType,
      gaugeOption: gaugeOption,
      countGaugeOnly: gaugeOnly,
      repeats: repeats,
      nth: nth,
    },
    last: null, // last describe() result
    get lastCount() {
      return api.last ? api.last.count : null;
    },
    count: countCart,
    describe: describe,
    fill: fill,
    render: render,
    hydrate: hydrate,
    refresh: refresh,
  };

  function render(count) {
    var d = describe(count);
    api.last = d;
    paintAll(document, d);
    document.dispatchEvent(new CustomEvent('splectrum:pack-count', { detail: d }));
    return d;
  }

  // Paint a subtree (newly injected HTML) from what we already know.
  function hydrate(scope) {
    if (!api.last) return;
    paintAll(scope, api.last);
  }

  var inflight = null;
  function refresh() {
    if (document.hidden) return inflight || Promise.resolve(null);
    if (inflight) return inflight;
    inflight = fetch(cartUrl, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        var n = countCart(cart);
        return n === null ? null : render(n);
      })
      .catch(function () {
        return null;
      })
      .then(function (d) {
        inflight = null;
        return d;
      });
    return inflight;
  }

  function onCartUpdate(event) {
    // /cart/change.js (quantity edits, quick-add-bulk) hands us the whole cart;
    // /cart/add.js (product forms) only returns the added line, so re-fetch.
    var data = event && event.cartData;
    if (isCart(data)) {
      render(countCart(data));
    }
    refresh();
  }

  /* ---- late-arriving markup ------------------------------------------- */
  var pending = [];
  var scheduled = false;
  function flushPending() {
    scheduled = false;
    var batch = pending;
    pending = [];
    var adopt = null;
    batch.forEach(function (node) {
      if (!node.isConnected) return;
      var carriers = [];
      if (node.matches && node.matches('[data-pick-count]')) carriers.push(node);
      var inner = node.querySelectorAll ? node.querySelectorAll('[data-pick-count]') : [];
      for (var i = 0; i < inner.length; i++) carriers.push(inner[i]);
      carriers.forEach(function (c) {
        // Only trust counts we did not write ourselves (fresh Liquid output).
        if (c.__splectrumPainted) return;
        var n = parseInt(c.getAttribute('data-pick-count'), 10);
        if (!isNaN(n)) adopt = n;
      });
    });
    if (adopt !== null && (!api.last || adopt !== api.last.count)) {
      render(adopt);
      refresh();
    } else {
      batch.forEach(function (node) {
        if (node.isConnected) hydrate(node);
      });
    }
    markPainted(document);
  }

  function markPainted(scope) {
    var all = scope.querySelectorAll('[data-pick-count]');
    for (var i = 0; i < all.length; i++) all[i].__splectrumPainted = true;
  }

  function observe() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      var hit = false;
      records.forEach(function (rec) {
        for (var i = 0; i < rec.addedNodes.length; i++) {
          var n = rec.addedNodes[i];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(SURFACES)) || (n.querySelector && n.querySelector(SURFACES))) {
            pending.push(n);
            hit = true;
          }
        }
      });
      if (hit && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flushPending);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- boot ------------------------------------------------------------ */
  function boot() {
    // Seed from the Liquid-rendered state so the first paint has no gap, then confirm.
    var seed = document.querySelector('[data-pick-count]');
    if (seed) {
      var n = parseInt(seed.getAttribute('data-pick-count'), 10);
      if (!isNaN(n)) {
        api.last = describe(n);
        markPainted(document);
      }
    }
    observe();
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  window.SplectrumPack = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
